import React from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css'; // Import the CSS file

const Navbar = () => {
  return (
    <nav className="navbar">
      <ul className="navbar-list">
        <li className="navbar-item"><Link to="/array">Array</Link></li>
        <li className="navbar-item"><Link to="/stack">Stack</Link></li>
        <li className="navbar-item"><Link to="/queue">Queue</Link></li>
        <li className="navbar-item"><Link to="/linkedlist">List</Link></li>
        <li className="navbar-item"><Link to="/tree">Tree</Link></li>
        {/* Add more links for other structures */}
      </ul>
    </nav>
  );
};

export default Navbar;
